export default "__VITE_ASSET__BHNc7Js6__"